/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_VideoInputs */

const en_story_video = /** @type {(inputs: Story_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const es_story_video = /** @type {(inputs: Story_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const fr_story_video = /** @type {(inputs: Story_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo`)
};

const de_story_video = /** @type {(inputs: Story_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const id_story_video = /** @type {(inputs: Story_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

/** @type {(inputs: Story_VideoInputs) => LocalizedString} */
const ja_story_video = en_story_video;

/** @type {(inputs: Story_VideoInputs) => LocalizedString} */
const zh_story_video = en_story_video;

/** @type {(inputs: Story_VideoInputs) => LocalizedString} */
const ar_story_video = en_story_video;

/** @type {(inputs: Story_VideoInputs) => LocalizedString} */
const it_story_video = en_story_video;

/** @type {(inputs: Story_VideoInputs) => LocalizedString} */
const ru_story_video = en_story_video;

/** @type {(inputs: Story_VideoInputs) => LocalizedString} */
const pt_story_video = en_story_video;

/** @type {(inputs: Story_VideoInputs) => LocalizedString} */
const ko_story_video = en_story_video;

/**
* | output |
* | --- |
* | "Video" |
*
* @param {Story_VideoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_video = /** @type {((inputs?: Story_VideoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_VideoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_video(inputs)
	if (locale === "es") return es_story_video(inputs)
	if (locale === "fr") return fr_story_video(inputs)
	if (locale === "de") return de_story_video(inputs)
	if (locale === "ja") return ja_story_video(inputs)
	if (locale === "zh") return zh_story_video(inputs)
	if (locale === "ar") return ar_story_video(inputs)
	if (locale === "id") return id_story_video(inputs)
	if (locale === "it") return it_story_video(inputs)
	if (locale === "ru") return ru_story_video(inputs)
	if (locale === "pt") return pt_story_video(inputs)
	return ko_story_video(inputs)
});